import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { movies, categories } from '@/mocks/movies';

interface MovieGridProps {
  categorySlug: string;
  limit?: number;
}

export default function MovieGrid({ categorySlug, limit }: MovieGridProps) {
  let filteredMovies = categorySlug === 'all'
    ? movies
    : movies.filter((m) => m.category === categorySlug);

  const displayMovies = limit ? filteredMovies.slice(0, limit) : filteredMovies;

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : '';
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-5">
      {displayMovies.map((movie) => (
        <MovieCard
          key={movie.id}
          id={movie.id}
          title={movie.title}
          year={movie.year}
          rating={movie.rating}
          image={movie.image}
          quality={movie.quality}
          categoryName={getCategoryName(movie.category)}
        />
      ))}
    </div>
  );
}